import Vue from 'vue'
import PreviewPag from "./PreviewPag.vue";
const PreviewPagConstructor = Vue.extend(PreviewPag)

export const previewPag = (options) => {
  const instance = new PreviewPagConstructor({
    data: {
      ...options,
    }
  })

  document.body.appendChild(instance.$mount().$el)

  instance.$watch('visible', () => {
    if (!instance.visible) {
      setTimeout(() => {
        if (instance.$el && instance.$el.parentNode === document.body) {
          document.body.removeChild(instance.$el)
        }
      }, 300)
    }
  })

  return instance
}
